import type { AlertFilters } from '../types';

/**
 * Every cache key the notifications feature uses. Any change to a notification drops
 * {@link alertKeys.all}, which takes the list, the counts and the bell's badge with it.
 */
export const alertKeys = {
  all: ['alerts'] as const,

  /** One filtered list, every page loaded so far. */
  list: (filters: AlertFilters) => [...alertKeys.all, 'list', filters] as const,

  /** The four counts. */
  summary: () => [...alertKeys.all, 'summary'] as const,
} as const;
